import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';

export default class CheckBoxThreeStateColumnFactory extends ColumnFactory {

    public static isPlainText = false;
    public static isJQueryElement = true;

    constructor(params: any) {
        super(params);
    }

    public getValue(): JQuery<HTMLElement> {
        let checked = this.raw as boolean | null;
        let text = checked == null
            ? '&#9724;' // schwarzes Quadrat
            : checked
                ? '&#10003;' // Checkmark
                : '';
        let cb = '<div class="c-control c-checkbox c-style-default c-state-disabled c-gridCell" data-checked="' + checked + '" ><div class="element" tabindex="0">' + text + '</div></div>';
        return $(cb);
    }
}

ComponentManager.setFactory('CheckBoxThreeStateColumn', CheckBoxThreeStateColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');